module.exports = __webpack_public_path__ + "img/mobile_icon.ffd5e7c2.png";